<template>
  <div class="page-wrap">
    <div v-for="(item, idx) in banner" :key="idx" :class="['banner-item', {'large-banner': item.type === 'max_title'}, {'small-banner': item.type === 'min_title'}]">
      <h3>{{item.title}}</h3>
      <p>{{item.desc}}</p>
    </div>
    <div v-if="label" class="label-wrap" :style="{background: label['background-color']}">
      <div v-for="(card, idx) in label.list" :key="idx" class="label-item">
        <img-v3 v-if="card.icon_img_url" class="card-icon" :src="card.icon_img_url" />
        <h3>{{card.title}}</h3>
        <p>{{card.desc}}</p>
        <send-email-input v-if="card.input_type === 'email'" :formItem="card"></send-email-input>
        <input
          v-if="card.input_type === 'link'"
          class="link-input"
          type="text"
          v-model="card.value"
          disabled
        />
      </div>
    </div>
    <template v-if="link">
      <div class="link-wrap"
        v-for="(linkItem, idx) in link.list" :key="'link' + idx"
        :style="{background: label['background-color']}"
        @click="goLink(linkItem)">
        <img-v3 v-if="linkItem.icon_url" class="link-icon" :src="linkItem.icon_url" />
        <span class="link-title">{{linkItem.title}}</span>
        <span class="arrow-icon"></span>
      </div>
    </template>


  </div>
</template>

<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { setTitle } from "../../tools/setTitle";
import { showLoadingToast, showAlertDialog } from "../../tools/Tip";
import SendEmailInput from "./send-email-input";

export default {
  name: "introduce",
  components: {
    SendEmailInput
  },
  data() {
    return {
      clearIconUrl: require("../../images/clear@2x.png"),
      hasClear: false,
      backConfig: {},
    };
  },
  computed: {
    ...mapState(["_ticket"]),
    //传递过来整个对象
    formItem() {
      let c = this.$route.params.configs;
      return c || this.backConfig || {};
    },
    banner() {
      return this.formItem.banner || [];
    },
    label() {
      return this.formItem.label
    },
    link() {
      return this.formItem.link
    }
  },
  created() {
    setTitle(this.formItem.title)
  },
  mounted() {
    let up = new URLSearchParams(location.search);
    let route_name = up.get("doc_route_name");
    if (route_name) {
      this.reloadConfig();
    }
  },
  methods: {
    back() {
      this.$router.replace({ name: "home" });
    },
    reloadConfig() {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      post(process.env.PHOTOINFO_URL, up)
        .then(data => {
          this.toast.hide();
          let job_type = up.get("doc_job_type");
          let result = data.form.filter(x => x.job_type === job_type);
          if (result.length) {
            this.backConfig = result[0];
          } else {
            this.back();
          }
        })
        .catch(res => {
          this.toast.hide();
          showAlertDialog(this, res.errmsg);
        });
    },
    goLink(linkItem){
      if (linkItem.target == "blank") {
        location.href = linkItem.link;
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-wrap {
  box-sizing: border-box;
  padding: 0.32rem 0.24rem 0.74rem;
  background: #F5F5F7;
  .banner-item h3,
  .label-item h3 {
    line-height: 0.52rem;
    font-weight: bold;
    color: #333333;
  }
  .banner-item p,
  .label-item p {
    line-height: 0.42rem;
    color: #666666;
    font-size: 0.28rem;
  }
  .banner-item {
    padding: 0 0.08rem;
    margin-bottom: 0.4rem;
    &.large-banner {
      h3{
        font-size: 0.4rem;
      }
      p{
        margin-top: 0.24rem;
      }
    }
    &.small-banner {
      h3{
        line-height: 1;
        font-size: 0.32rem;
      }
      p{
        margin-top: 0.12rem;
      }
    }
  }
  .label-wrap {
    width: 100%;
    // height: 9.85rem;
    padding: 0 0.32rem;
    box-sizing: border-box;
    border-radius: 0.24rem;
  }
  .label-item {
    padding: 0.32rem 0 0.6rem;
    margin-bottom: 0.28rem;
    text-align: center;
    border-bottom: 1px solid rgba(0,0,0,0.08);
    &:last-child {
      margin-bottom: 0;
      border: none;
    }
    img {
      width: 0.8rem;
      height: 0.8rem;
    }
    h3 {
      font-size: 0.4rem;
    }
    p {
      margin-top: 0.12rem;
    }
  }
  // .email-input-wrap {
  //   position: relative;
  //   display: flex;
  //   align-items: center;
  //   width: 100%;
  //   height: 1.1rem;
  //   margin-top: 0.32rem;
  //   border-radius: 0.12rem;
  //   .email-input {
  //     width: 100%;
  //     height: 100%;
  //     box-sizing: border-box;
  //     padding: 0.34rem 1.9rem 0.34rem 0.24rem;
  //     background: #F3F7F7;
  //     border-radius: 0.12rem;
  //     font-weight: 500;
  //     font-size: 0.36rem;
  //     color: #333333;
  //     vertical-align: bottom;
  //   }
  //   .clear-icon {
  //     position: absolute;
  //     right: 1.38rem;
  //     width: 0.32rem;
  //     height: 0.32rem;
  //     cursor: pointer;
  //   }
  //   .submit-icon {
  //     position: absolute;
  //     right: 0;
  //     width: 1.1rem;
  //     height: 1.1rem;
  //     cursor: pointer;
  //   }
  // }
  .link-input {
    display: block;
    margin-top: 0.32rem;
    width: 100%;
    height: 1.02rem;
    box-sizing: border-box;
    background: rgba(255,114,38,0.02);
    border: 0.1rem solid rgba(255,114,38,0.10);
    border-radius: 0.12rem;
    text-align: center;
    font-size: 0.32rem;
    font-weight: 500;
    color: #FF7226;
    -webkit-appearance: none;
    &:disabled {
      background: rgba(255,114,38,0.02);
      color: #FF7226;
      -webkit-text-fill-color: #FF7226;
      opacity:1;
      -webkit-opacity:1;
    }
  }
  .link-wrap {
    position: relative;
    margin-top: 0.2rem;
    padding: 0 0.32rem;
    width: 100%;
    height: 1.2rem;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-radius: 0.24rem;
    .link-icon {
      // width: 0.28rem;
      height: 0.36rem;
      margin-right: 0.2rem;
    }
    .link-title {
      font-size: 0.32rem;
      color: #333333;
      font-weight: 500;
    }
  }
  .arrow-icon {
    position: absolute;
    display: inline-block;
    width: 0.15rem;
    height: 0.15rem;
    right: 0.32rem;
    border-top: 0.04rem solid #0F1419;
    border-right: 0.04rem solid #0F1419;
    transform: rotate(45deg);
  }
}
</style>
